module.exports = __webpack_public_path__ + "img/20190523212420微信截图_20190523212807.png.a771731f.png";